const productBarsInit = () => {
  const loaderElements = document.querySelectorAll('.loader-bar') as NodeListOf<HTMLElement>;
  const headerElement = document.querySelector('.panel__header') as HTMLElement;

  const growFillers = () => {
    loaderElements.forEach((loader) => {
      const fillerElement = loader.lastElementChild as HTMLElement;
      const dataLoader = loader.dataset.loader;
      setTimeout(() => {
        fillerElement.classList.add(dataLoader);
      }, 250);
    });
  };

  // start animation when clicked on description header
  headerElement.addEventListener('click', () => {
    growFillers();
  });
};

export default productBarsInit;
